import { type Annotation, InternalProgramType } from '@tempus/trials-types';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const annotationsApi = {
  get: async (params: { trialId: string; programType: InternalProgramType }): Promise<Annotation[]> => {
    return axios.get(`${TRIALS_API_ROOT}/annotations`, { params }).then(({ data }) => data.data);
  },
};
